export default "__VITE_ASSET__BKYXqLIm__"